import { AxiosResponse } from 'axios';
import { appContextGet, appContextPost, appContextPut } from './httpCommon/appAxios.service';
import {
  OnFarmDepositRequestBody,
  OnFarmUseRequestBody,
  OnFarmWithdrawRequestBody,
  OnFarmDiscardRequestBody,
  OnFarmSellRequestBody,
  OnFarmMoveRequestBody,
  OnFarmTransactionExportRequest,
  OnFarmLinkedStorageMovement,
} from '../types/interfaces/onFarmTransaction.interfaces';
import { OnFarmSpecimenLocation } from '../types/interfaces/onFarmSpecimen.interfaces';
import { ON_FARM_TRANSACTION_API_ENDPOINTS } from '../constants/apiEndpoints';

export const onFarmDepositPost = (
  accountId: number,
  depositValues: OnFarmDepositRequestBody,
): Promise<AxiosResponse<number, any>> => {
  return appContextPost(ON_FARM_TRANSACTION_API_ENDPOINTS.DEPOSIT, depositValues, { accountId });
};

export const onFarmUsePost = (accountId: number, useValues: OnFarmUseRequestBody): Promise<AxiosResponse<number, any>> => {
  return appContextPost(ON_FARM_TRANSACTION_API_ENDPOINTS.USE, useValues, { accountId });
};

export const onFarmWithdrawPost = (withdrawValues: OnFarmWithdrawRequestBody): Promise<AxiosResponse<number, any>> => {
  return appContextPost(ON_FARM_TRANSACTION_API_ENDPOINTS.WITHDRAW, withdrawValues);
};

export const onFarmDiscardPost = (discardValues: OnFarmDiscardRequestBody): Promise<AxiosResponse<number, any>> => {
  return appContextPost(ON_FARM_TRANSACTION_API_ENDPOINTS.DISCARD, discardValues);
};

export const downloadOnFarmBulkDepositTemplate = (): Promise<AxiosResponse<Blob, any>> => {
  return appContextGet(ON_FARM_TRANSACTION_API_ENDPOINTS.BULK_DEPOSIT_TEMPLATE, {}, { responseType: 'blob' });
};

export const uploadOnFarmBulkDeposit = (file: File, accountId: number): Promise<AxiosResponse<void, any>> => {
  const formData = new FormData();
  formData.append('file', file);
  return appContextPost(ON_FARM_TRANSACTION_API_ENDPOINTS.BULK_DEPOSIT_UPLOAD, formData, { accountId });
};

export const getOnFarmCanisterInventory = (
  accountStorageCanisterId: number,
): Promise<AxiosResponse<OnFarmSpecimenLocation[], any>> => {
  return appContextGet(ON_FARM_TRANSACTION_API_ENDPOINTS.CANISTER_INVENTORY, { accountStorageCanisterId });
};

export const requestOnFarmMoveInventory = (moveInventoryValues: OnFarmMoveRequestBody): Promise<AxiosResponse<number, any>> => {
  return appContextPost(ON_FARM_TRANSACTION_API_ENDPOINTS.MOVE, moveInventoryValues);
};

export const onFarmSellPost = (sellValues: OnFarmSellRequestBody): Promise<AxiosResponse<number, any>> => {
  return appContextPost(ON_FARM_TRANSACTION_API_ENDPOINTS.SELL, sellValues);
};

export const downloadOnFarmTransactionReport = (payload?: {}, query?: {}): Promise<AxiosResponse<any, any>> => {
  return appContextPost(ON_FARM_TRANSACTION_API_ENDPOINTS.EXPORT, payload, query, { responseType: 'blob' });
};

export const exportOnFarmTransaction = (payload: OnFarmTransactionExportRequest): Promise<AxiosResponse<Blob, any>> => {
  return appContextPost(ON_FARM_TRANSACTION_API_ENDPOINTS.EXPORT, payload, {}, { responseType: 'blob' });
};

export const cancelOnFarmTransaction = (onFarmTransactionId: number): Promise<AxiosResponse<void, any>> => {
  return appContextPut(ON_FARM_TRANSACTION_API_ENDPOINTS.CANCEL + onFarmTransactionId, {});
};

export const getOnFarmLinkedStorageMovements = (
  onFarmTransactionId: number,
): Promise<AxiosResponse<OnFarmLinkedStorageMovement[], any>> => {
  return appContextGet(
    `${ON_FARM_TRANSACTION_API_ENDPOINTS.LINKED_STORAGE_MOVEMENT}/${onFarmTransactionId}/linked-storage-movement`,
  );
};
